import { c as _c } from "react/compiler-runtime";
import { DEFAULT_WAREHOUSE_ID } from 'commons/constants';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useIsBrowser from 'hooks/useIsBrowser';
import { GET_WAREHOUSE_ID_FOR_ZIPCODE } from 'mocks/queries';
const DEFAULT_VALUE = {
  error: undefined,
  loading: false,
  refetch: () => {},
  warehouseId: DEFAULT_WAREHOUSE_ID
};
const useWarehouseIdForZipCode = zipcode => {
  const $ = _c(10);
  const isBrowser = useIsBrowser();
  let t0;
  if ($[0] !== zipcode) {
    t0 = {
      zipcode
    };
    $[0] = zipcode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !zipcode;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      variables: t0,
      skip: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data,
    error,
    loading,
    refetch
  } = useSuspenseQuery(GET_WAREHOUSE_ID_FOR_ZIPCODE, t2);
  if (!zipcode || !isBrowser || !data?.getWarehouseIdFromZip?.warehouseId || data.getWarehouseIdFromZip.warehouseId === "Not Found") {
    return DEFAULT_VALUE;
  }
  const t3 = loading && !data;
  const t4 = data?.getWarehouseIdFromZip?.warehouseId ?? DEFAULT_WAREHOUSE_ID;
  let t5;
  if ($[5] !== error || $[6] !== refetch || $[7] !== t3 || $[8] !== t4) {
    t5 = {
      error,
      loading: t3,
      refetch,
      warehouseId: t4
    };
    $[5] = error;
    $[6] = refetch;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default useWarehouseIdForZipCode;